import styled from 'styled-components'

const FiltersWrapper = styled.div`
    padding: 16px 24px;
`

export {
    FiltersWrapper
}